import * as S from "./styled";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
/**
 * Components
 */
import LayoutWithList from "../../../LayoutModal/WithList";
import ActionButton from "../../../Button/ActionButton";
import Delete from "../../../../components/Modals/Delete";
import Update from "../Update";
/**
 * hooks
 */
import apiRequest from "../../../../hooks/apiRequest";
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
import { useEffect, useState } from "react";
/**
 * Icons
 */
import { PencilSimple, Trash } from "@phosphor-icons/react";
/**
 * Interfaces
 */
import { Inputs, IMaterials } from "Interfaces/IMaterials";

interface ICreate {
  isOpenModalMaterial: boolean;
  setModalClose: () => void;
  refreshFrames: () => void;
}

export default function CreateMaterial({
  isOpenModalMaterial,
  setModalClose,
  refreshFrames,
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const tableHead = ["#", "Nome", "Ações"];

  const [material, setMaterial] = useState<IMaterials[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();

  const clickPopTable = (id: number, acao: string) => {
    setOpenModalOptId(id);
    toggleModalVisibility(acao);
  };

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(`material`);
      setMaterial(response.data);
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  useEffect(() => {
    if (isOpenModalMaterial && material.length === 0) {
      fetchData();
    }
  }, [isOpenModalMaterial]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {

      const formattedData = {
        ...data,
        material: data.material.toUpperCase(), // Aqui você força caixa alta
      };

      const response = await apiRequest("material", "POST", formattedData);
      if (response.status === 201) {
        alert("Tipo de armação criado com sucesso!");
        fetchData();
        refreshFrames();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o fornecedor.");
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  };

  if (isOpenModalMaterial) {
    return (
      <LayoutWithList
        title="Registrar Tipo de Armação"
        subTitle="Cadastre um novo tipo de armação em sua base de dados."
        setModalClose={onClose}
      >
        <S.Container>
          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Tipo de Armação
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o tipo de armação"
                type="text"
                {...register("material", { required: true })}
              />
              {errors.material && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>

            <S.ContentButton>
              <ActionButton
                name="Salvar"
                onClick={handleFormSubmit(onSubmit)}
              />
            </S.ContentButton>
          </S.SeparateDiv>
        </S.Container>

        <S.Footer>
          <S.TitleList>Tipo de Armações Cadastrados</S.TitleList>

          <S.Table>
            <thead>
              <tr>
                {tableHead.map((val) => {
                  return <th>{val}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {material.map((val, index) => {
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{val.material}</td>
                    <td>
                      <S.ContentButton>
                        <S.ButtonIconTable
                          onClick={() => clickPopTable(val.id, "update")}
                        >
                          <PencilSimple size={20} />
                        </S.ButtonIconTable>

                        <S.ButtonIconTable
                          onClick={() => clickPopTable(val.id, "delete")}
                        >
                          <Trash size={20} color="red" />
                        </S.ButtonIconTable>
                      </S.ContentButton>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </S.Table>
        </S.Footer>

        <Update
          isOpenModalMaterial={isOpenModal("update")}
          setModalClose={() => toggleModalVisibility("update")}
          selectedUrlId={openModalOptId}
          updateList={fetchData}
        />

        <Delete
          updateList={fetchData}
          endpoint="material"
          selectedProductId={openModalOptId}
          isOpenModal={isOpenModal("delete")}
          setModalClose={() => toggleModalVisibility("delete")}
        />
      </LayoutWithList>
    );
  }
  return null;
}
